
(function () {
  'use strict';

  const CARD_SELECTOR = '[data-jg-card-price]';
  const CARD_WRAPPER_SELECTOR = '.card-wrapper';
  const BADGE_SELECTOR = '.discounty-volume-badge__text';

  function updateCardPrice(priceContainer) {
    const nativePrice = priceContainer.querySelector(
      '[data-jg-card-native-price]'
    );

    const bulkPrice = priceContainer.querySelector(
      '[data-jg-card-bulk-price]'
    );

    const bulkValue = priceContainer.querySelector(
      '[data-jg-card-bulk-value]'
    );

    if (!nativePrice || !bulkPrice || !bulkValue) return;

    // 默认保留 Shopify 原生价格
    function showNativePrice() {
      nativePrice.hidden = false;
      bulkPrice.hidden = true;
    }

    // 只有明确标记参加活动的商品才继续
    const eligible =
      priceContainer.dataset.jgDiscountyEligible === 'true';

    if (!eligible) {
      showNativePrice();
      return;
    }

    const cardWrapper = priceContainer.closest(
      CARD_WRAPPER_SELECTOR
    );

    if (!cardWrapper) {
      showNativePrice();
      return;
    }

    // 查找当前商品卡片内的 Discounty 标签
    const badge = cardWrapper.querySelector(BADGE_SELECTOR);

    if (!badge) {
      showNativePrice();
      return;
    }

    const discountText = badge.textContent.trim();

    // 必须是有效的 From 价格
    if (!/^From\s+\$?[\d,.]+/i.test(discountText)) {
      showNativePrice();
      return;
    }

    bulkValue.textContent = discountText;

    nativePrice.hidden = true;
    bulkPrice.hidden = false;
  }

  function updateAllCards() {
    document.querySelectorAll(CARD_SELECTOR).forEach(
      updateCardPrice
    );
  }

  let scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateAllCards();
    });
  }

  function init() {
    updateAllCards();

    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener(
      'shopify:section:load',
      scheduleUpdate
    );

    window.addEventListener('pageshow', scheduleUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
